/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Tue, Jul 20th 2021, 2:49:34 pm
 *
 * *****************************************************
 */

import { ReactComponent as Logo } from 'assets/images/logo.svg';

import { LayoutContainer, LayoutHeader, LayoutBlock } from './styles';

type Props = {
  children: React.ReactNode;
};

/**
 * Layout for authentication feature.
 */
const AuthLayout = ({ children }: Props): JSX.Element => (
  <LayoutContainer>
    <LayoutHeader>
      <Logo />
    </LayoutHeader>
    <main>
      <LayoutBlock>{children}</LayoutBlock>
    </main>
  </LayoutContainer>
);

export default AuthLayout;
